import { combineReducers }    from 'redux';

import authReducer            from "./auth/authReducer";
import themeReducer           from './theme/themeReducer';
import audioReducer           from "./audio/audioReducer";
import dialogsReducer         from "./dialogs/dialogsReducer";
import transcriptsReducer     from "./transcripts/transcriptsReducer";
import filterReducer          from "./filter/filterReducer";
import trashReducer           from "./trash/trashReducers";

const rootReducer = combineReducers({
  authReducer,
  themeReducer,
  audioReducer,
  dialogsReducer: dialogsReducer,
  transcriptsReducer,
  filterReducer,
  trashReducer
});

export default rootReducer;

